import { useCallback, useContext, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeleteConfirm } from "../../../../../../../hooks/useDeleteConfirm"
import { useApplicationPermissionFirmwareConstraintRoles } from "../../../../../../../hooks/useApplicationPermissionFirmwareConstraintRoles"
import { deleteEntity } from "../../../../../../utils/deleteEntity"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../../../models/Authorization"
import { UserContext } from "../../../../../../context/UserContext"
import { DiMaAddButton } from "../../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../../partials/EntityTab"

export function ApplicationPermissionFirmwareConstraintRoles() {
  const { applicationId, permissionId, firmwareConstraintId } = useParams()
  const { user } = useContext(UserContext)
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const { firmwareConstraintRoles, isLoadingFirmwareConstraintRoles } =
    useApplicationPermissionFirmwareConstraintRoles(applicationId, permissionId, firmwareConstraintId)

  const canDelete =
    !!user &&
    hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      applicationId ?? "",
      DimaFeatureShortNameEnum.AM,
      AccessLevel.Write
    )

  const cols = [{ field: "name", headerName: "Role" }]

  const rows = firmwareConstraintRoles.map((role, index) => ({
    id: String(index),
    name: role.name,
    deleteUrl: `/applications/${applicationId}/permissions/${permissionId}/firmwareConstraints/${firmwareConstraintId}/roles/${role.id}`,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/permissions/${permissionId}/firmware-constraints/${firmwareConstraintId}/roles/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationId, permissionId, firmwareConstraintId]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(row.deleteUrl as string))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingFirmwareConstraintRoles}
        toolbar={toolbar}
        actionItems={
          canDelete ? [{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }] : []
        }
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
